import React from 'react';
import { withTranslation } from 'react-i18next';
import './BlockBikeMap.scss';
import { FcShop } from 'react-icons/fc';

class BlockBikeMap extends React.Component<any, any> {

    render() {
        return (
            <div className="BlockBikeMap">
                <FcShop className='imgHeader' />
                <h3 className='description'>{this.props.t('SampleBikePageBikeBlockBikeMoreBike')}</h3>
                <div className='linksLine'>
                    {/* eslint-disable-next-line */}
                    <a className='linkFindUshop' onClick={() => this.props.displayRightPage()}>{this.props.t('SampleBikePageBikeBlockBikeFoundShop')}</a>
                </div>
            </div>
        );
    }
}

export default withTranslation()(BlockBikeMap);